/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Tournament } from './Tournament';
import {
    TournamentFromJSON,
    TournamentFromJSONTyped,
    TournamentToJSON,
    TournamentToJSONTyped,
} from './Tournament';

/**
 * Result of archiving a tournament
 * @export
 * @interface TournamentArchiveResponse
 */
export interface TournamentArchiveResponse {
    /**
     * 
     * @type {Tournament}
     * @memberof TournamentArchiveResponse
     */
    tournament: Tournament;
    /**
     * 
     * @type {string}
     * @memberof TournamentArchiveResponse
     */
    message: string;
}

/**
 * Check if a given object implements the TournamentArchiveResponse interface.
 */
export function instanceOfTournamentArchiveResponse(value: object): value is TournamentArchiveResponse {
    if (!('tournament' in value) || value['tournament'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function TournamentArchiveResponseFromJSON(json: any): TournamentArchiveResponse {
    return TournamentArchiveResponseFromJSONTyped(json, false);
}

export function TournamentArchiveResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentArchiveResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tournament': TournamentFromJSON(json['tournament']),
        'message': json['message'],
    };
}

export function TournamentArchiveResponseToJSON(json: any): TournamentArchiveResponse {
    return TournamentArchiveResponseToJSONTyped(json, false);
}

export function TournamentArchiveResponseToJSONTyped(value?: TournamentArchiveResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tournament': TournamentToJSON(value['tournament']),
        'message': value['message'],
    };
}

